<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-file-input 
      :label="label" 
      :class="evaluateClasses(classes)" 
      :regular="isRegular"
      :solo="isSolo"
      :outlined="isOutlined"
      :filled="isFilled"
    ></v-file-input>
  </dr-wrapper>
  <dr-file-input-component v-else-if="isVisible" v-bind="$props" :class="evaluateClasses(classes)" @callDataSourceAction="$emit('callDataSourceAction', $event)"></dr-file-input-component>
</template>

<script>

import inputMixin from '../../mixins/input-mixin'
import baseMixin from '../../mixins/base-mixin'
import drFileInputComponent from './dr-file-input-component'

export default {
  mixins: [inputMixin, baseMixin],
  components: {
    drFileInputComponent
  },
  computed: {
    label() {
      return this.evaluateExpression(this.model.Label)
    }
  }
}
</script>